import { useMemo, useState } from 'react';

import { SiteSummary } from '../../../models';

import SiteElement from './Site';
import TableContainer from '../../ui/Table/Container';

import { ApiError, PortfolioQuery } from 'src/api';

import EmptySearchIcon from 'src/assets/icons/empty-search-icon.svg';
import EmptyFilterIcon from 'src/assets/icons/empty-filter-icon.svg';

interface Props {
  pageElements: SiteSummary[];
  noFiltersSelected: boolean;
  loading: boolean;
  error?: ApiError;
  showEquipmentList: boolean;
  siteFetchTime?: Date;
  query: PortfolioQuery;
}

const PortfolioTableContainer = ({
  pageElements,
  noFiltersSelected,
  loading,
  error,
  showEquipmentList,
  siteFetchTime,
  query,
}: Props) => {
  const [showPriority, setShowPriority] = useState(true);
  console.log('pageElements', pageElements);

  const elements = useMemo(() => {
    if (showPriority) {
      return pageElements;
    }
    console.log('pageElements', pageElements);

    return pageElements.filter((site) => !site.highestActiveAlarmCount);
  }, [pageElements, showPriority]);

  const priorityHandler = () => {
    setShowPriority((prevState) => !prevState);
  };

  return (
    <TableContainer<SiteSummary>
      elements={elements}
      emptyStateDescription={
        noFiltersSelected
          ? 'Check your search terms, or search for something else'
          : 'Adjust or check your filter settings, and try again.'
      }
      emptyStateTitle={noFiltersSelected ? 'No sites found.' : 'No filter results.'}
      getPriority={(site) => !!site.highestActiveAlarmCount}
      Icon={noFiltersSelected ? EmptySearchIcon : EmptyFilterIcon}
      labelPriority="Sites with warnings"
      priorityHandler={priorityHandler}
      qtyPriority={pageElements.filter((site) => !!site.highestActiveAlarmCount).length}
      showPriority={showPriority}
      loading={loading}
      error={error}
      query={query}
      getContent={(site) => (
        <SiteElement
          address={site.fullAddress}
          endUserName={site.endUserName}
          highestActiveAlarmCount={site.highestActiveAlarmCount}
          installerName={site.installerCompanyName}
          name={site.name}
          siteId={site.siteId}
          equipment={site.equipment ? site.equipment : []}
          showEquipmentList={showEquipmentList}
          isOnline={site.isOnline}
          siteFetchTime={siteFetchTime}
        />
      )}
    />
  );
};

export default PortfolioTableContainer;
